import { render, staticRenderFns } from "./showRich.vue?vue&type=template&id=d533cbee&scoped=true"
import script from "./showRich.vue?vue&type=script&lang=js"
export * from "./showRich.vue?vue&type=script&lang=js"
import style0 from "./showRich.vue?vue&type=style&index=0&id=d533cbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d533cbee",
  null
  
)

export default component.exports